import * as React from 'react';
import styled from 'styled-components';

import { safeFocus } from '../../core/Env';
import { useUpdateEffect } from '../../core/hooks';
import * as Modal from '../Modal';

import { makeSlot } from './slots';
import { useFormContext } from './Form';

export const Control = makeSlot('control')(({ target: Target, focused, className, name, ...props }) => {

    const refTarget = React.useRef<HTMLInputElement>(null);

    const { 
        showed, 
        getFocus, 
        focused: focusin, 
        blured,
    } = Modal.useContext();


    useUpdateEffect(() => {
        safeFocus(refTarget)();
    }, [focused]);


    React.useEffect(() => {
        if(showed){
            
            if(!getFocus()){
                focusin();
                safeFocus(refTarget)();
            }

        }
        else {
            blured();
        }
    }, [showed]);


    const form = useFormContext();
    form.registry(name);


    return (
        <ControlS className={className}>
            <Target 
                ref={refTarget}
                name={name}
                {...props}
            />
        </ControlS>
    );
});

const ControlS = styled.div`
    position: relative;
    grid-area: control;
    min-height: 40px;
    display: flex;
`;
